

import { useState, useRef, useEffect } from "react"
import PdfViewer from "../../pages/PdfViewer"
import Button from "@/components/ui/button"

export default function PdfEditor() {
  const [pdfFile, setPdfFile] = useState(null)
  const [isPreview, setIsPreview] = useState(false)
  const fileInputRef = useRef(null)

  // For preview purposes, load a sample PDF
  useEffect(() => {
    // Check if we're in a preview environment
    const checkPreview = async () => {
      try {
        // Try to load a sample PDF for preview
        const response = await fetch(
          "https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf",
        )
        if (response.ok) {
          const blob = await response.blob()
          const file = new File([blob], "sample.pdf", { type: "application/pdf" })
          setPdfFile(file)
          setIsPreview(true)
        }
      } catch (error) {
        console.log("Not in preview mode or couldn't load sample PDF")
      }
    }

    if (!pdfFile) {
      checkPreview()
    }
  }, [pdfFile])

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file && file.type === "application/pdf") {
      setPdfFile(file)
      setIsPreview(false)
    }
  }

  return (
    <main className="mx-auto max-h-[200vh] p-4 max-w-6xl">
      <h1 className="text-2xl font-bold mb-6">Interactive PDF Viewer</h1>

      <div className="mb-6">
        <input type="file" accept="application/pdf" onChange={handleFileChange} ref={fileInputRef} className="hidden" />
        <Button onClick={() => fileInputRef.current.click()}>
          {pdfFile && !isPreview ? "Change PDF" : "Select PDF"}
        </Button>
        {pdfFile && (
          <span className="ml-2 text-sm text-gray-600">{isPreview ? "Sample PDF (Preview Mode)" : pdfFile.name}</span>
        )}
      </div>

      <div className="w-full h-[1500px]">
        <PdfViewer file={pdfFile} />
      </div>
    </main>
  )
}

